/*
 * @Author: etong
 * @Date: 2021-07-02 15:02:04
 * @LastEditTime: 2022-07-08 16:26:23
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\api\commonPage\commonForm.js
 * Think first, Program later
 */
import request from '@/utils/request'

// 单据保存
const SaveDocument = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/SaveDocument',
    method: 'post',
    data: params
  })
}

// 获取详情
const GetDocumentById = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Query/GetSingleById',
    method: 'post',
    data: params
  })
}

// 创建审批流
const CreateJJFlow = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/CreateJJFlow',
    method: 'post',
    data: params
  })
}

// 通过
const commonApprove = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/Approve',
    method: 'post',
    data: params
  })
}

// 拒绝
const commonReject = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/Reject',
    method: 'post',
    data: params
  })
}

// 撤回
const commonReCall = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/ReCall',
    method: 'post',
    data: params
  })
}

// 保存并提交
const SaveDocumentAndSubmitApproval = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/SaveDocumentAndSubmitApproval',
    method: 'post',
    data: params
  })
}

// 查询单据节点关系图
const GetDocumentNodeRelationInfo = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/GetDocumentNodeRelationInfo',
    method: 'get',
    params
  })
}

// 查询单据节点关系图 + 层级
const GetDocumentTablesNodeRelationInfo = function(data) {
  const { module = 'bsc', params } = data
  return request({
    url: module + '/BSC/GetDocumentTablesNodeRelationInfo',
    method: 'get',
    params
  })
}

// 获取单据附件列表
const GetDocFileList = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/GetDocFileList',
    method: 'get',
    params
  })
}

// 根据RelationID和上游单据业务id初始化下游单据信息
const InitDownstreamDocument = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/InitDownstreamDocument',
    method: 'get',
    params
  })
}
// 获取翻页id
const GetPageTurningId = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Query/GetPageTurningId',
    method: 'post',
    data: params
  })
}

// 保存附件
const SaveFiles = function(data) {
  const { module = 'doc', params } = data
  console.log('SaveFiles', params, module + '/Documents/SaveFiles')
  return request({
    url: module + '/Documents/SaveFiles',
    method: 'post',
    data: params
  })
}
export default {
  SaveDocument,
  GetDocumentById,
  CreateJJFlow,
  commonApprove,
  commonReject,
  commonReCall,
  SaveDocumentAndSubmitApproval,
  GetDocumentNodeRelationInfo,
  GetDocFileList,
  InitDownstreamDocument,
  GetDocumentTablesNodeRelationInfo,
  GetPageTurningId,
  SaveFiles
}
